import { render, staticRenderFns } from "./contactcard.vue?vue&type=template&id=6b533381&scoped=true"
import script from "./contactcard.vue?vue&type=script&lang=js"
export * from "./contactcard.vue?vue&type=script&lang=js"
import style0 from "./contactcard.vue?vue&type=style&index=0&id=6b533381&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b533381",
  null
  
)

export default component.exports